// in here should lie the inital alert component that displays the modal
import React, { useEffect, useState } from "react";
import SignUpModal from "@hui/_molecules/modal/sign_up_modal/SignUpModal";
import MenuActions from "@hui/_molecules/modal/sign_up_modal/actions/menuItems"
import I18n from "../../../utilities/translations";
import StepOverview from "./StepOverview/StepOverview";
import { StepOverviewState } from "../../../API/onboarding/step_overview.api";
import AccountProvisionedForm from "./AccountProvisionedForm";
import AuthorityToVerifyIdentityForm from "./AuthorityToVerifyIdentity";
import BusinessRegistrationForm from "./BusinessRegistrationForm";
import PaymentConfirmed from "./PaymentConfirmed";
import PersonalBankAccountForm from "./PersonalBankAccountForm";
import PersonalDetailsForm from "./PersonalDetailsForm";
import ProofOfAddressForm from "./ProofOfAddressForm";
import ResendConfirmationEmailForm from "./ResendConfirmationEmailForm";
import SelfEmployedEstimateForm from "./SelfEmployedEstimateForm";
import TaxDetailsForm from "./TaxDetailsForm";
import IncomeDetailsForm from "./IncomeDetailsForm"
import VerifyIdentityBasicDetailsForm from "./VerifyIdentityBasicDetailsForm";
import VerifyIdentityExternalVerificationForm from "./VerifyIdentityExternalVerificationForm";
import WorkDetailsForm from "./WorkDetailsForm";
import { iOnboardingTourControls } from "./types/onboardingTypes";
import ConfirmYourIncomeForm from "./ConfirmYourIncomeForm";
import ChooseAnIdDocumentForm from "./ChooseAnIdDocumentForm";

const signupTourTitleFor = {
  business_registration: I18n.t("onboarding.v3.business_registration.title"),
  step_overview_1: I18n.t("onboarding.v3.step_overview.title"),
  self_employed_estimate: I18n.t("onboarding.v3.self_employed_estimate.title"),
  work_details: I18n.t("onboarding.v3.work_details.title"),
  income_details: I18n.t("onboarding.v3.income_details.title"),
  tax_details: I18n.t("onboarding.v3.tax_details.title"),
  step_overview_2: I18n.t("onboarding.v3.step_overview.title"),
  personal_details: I18n.t("onboarding.v3.personal_details.title"),
  step_overview_3: I18n.t("onboarding.v3.step_overview.title"),
  resend_confirmation_email: "Identity Verification",
  authority_to_verify_identity: "Authority to Verify Identity",
  verify_identity_basic_details: I18n.t("onboarding.v3.verify_identity_basic_details.title"),
  choose_an_id_document: I18n.t("onboarding.v3.choose_an_id_document.title"),
  proof_of_address: I18n.t("onboarding.v3.proof_of_address.title"),
  verify_identity_external_verification: I18n.t("onboarding.v3.verify_identity_external_verification.title"),
  account_provisioned: I18n.t("onboarding.v3.account_provisioned.title_loading"),
  step_overview_4: I18n.t("onboarding.v3.step_overview.title"),
  personal_bank_account: I18n.t("onboarding.v3.personal_bank_account.title"),
  confirm_your_income: I18n.t("onboarding.v3.confirm_your_income.title"),
  payment_confirmed: I18n.t("onboarding.v3.payment_confirmed.title"),
}

const OnboardingTourControls = ({ countryList, financialYearStart, financialYearEnd, intercomLink, onboardingState, runVerificationOnLoad, userId }: iOnboardingTourControls) => {
  const [tourState, setTourState] = useState(onboardingState || "business_registration")
  const [modalTitle, setModalTitle] = useState<string>()
  const [open, setOpen] = useState(true)

  useEffect(() => {
    setModalTitle(signupTourTitleFor[tourState])
  } , [tourState])

  const handleTourProgression = (nextStep) => {
    setTourState(nextStep)
  }

  const handleTitleUpdate = (title) => {
    setModalTitle(title)
  }

  const signupTourFormFor = {
    business_registration: <BusinessRegistrationForm stateUpdate={handleTourProgression} intercomLink={intercomLink}/>,
    step_overview_1: <StepOverview state={tourState as StepOverviewState} stateUpdate={handleTourProgression}/>,
    self_employed_estimate: <SelfEmployedEstimateForm stateUpdate={handleTourProgression} financialYearStart={financialYearStart} financialYearEnd={financialYearEnd}/>,
    work_details: <WorkDetailsForm stateUpdate={handleTourProgression} financialYearStart={financialYearStart} financialYearEnd={financialYearEnd}/>,
    income_details: <IncomeDetailsForm stateUpdate={handleTourProgression} />,
    tax_details: <TaxDetailsForm stateUpdate={handleTourProgression}/>,
    step_overview_2: <StepOverview state={tourState as StepOverviewState} stateUpdate={handleTourProgression}/>,
    personal_details: <PersonalDetailsForm stateUpdate={handleTourProgression} userId={userId}/>,
    step_overview_3: <StepOverview state={tourState as StepOverviewState} stateUpdate={handleTourProgression}/>,
    resend_confirmation_email: <ResendConfirmationEmailForm stateUpdate={handleTourProgression}/>,
    authority_to_verify_identity: <AuthorityToVerifyIdentityForm stateUpdate={handleTourProgression}/>,
    verify_identity_basic_details: <VerifyIdentityBasicDetailsForm stateUpdate={handleTourProgression} countryList={countryList}/>,
    choose_an_id_document: <ChooseAnIdDocumentForm stateUpdate={handleTourProgression} countryList={countryList} intercomLink={intercomLink}/>,
    proof_of_address: <ProofOfAddressForm stateUpdate={handleTourProgression}/>,
    verify_identity_external_verification: <VerifyIdentityExternalVerificationForm stateUpdate={handleTourProgression} intercomLink={intercomLink} runVerificationOnLoad={runVerificationOnLoad} userId={userId}/>,
    account_provisioned: <AccountProvisionedForm stateUpdate={handleTourProgression} handleTitleUpdate={handleTitleUpdate} userId={userId} intercomLink={intercomLink}/>,
    step_overview_4: <StepOverview state={tourState as StepOverviewState} stateUpdate={handleTourProgression}/>,
    personal_bank_account: <PersonalBankAccountForm/>,
    confirm_your_income: <ConfirmYourIncomeForm stateUpdate={handleTourProgression}/>,
    payment_confirmed: <PaymentConfirmed/>,
  }

  return (
    <>
      <SignUpModal
        open={open}
        setOpen={setOpen}
        title={modalTitle}
        moreActions={MenuActions({intercomLink})}
        options={{ onOpenAutoFocus: (event) => event.preventDefault(), hideOverlay:false }}>
        {signupTourFormFor[tourState]}
      </SignUpModal>
    </>
  );
};

export default OnboardingTourControls
